import PuestoService from "@/api/services/personal/nomencladores/PuestoService"
import Vue from "vue"

const state = () => ({
    puestos: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    PUESTOS: state => {
        return state.puestos
    },
    PUESTOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_PUESTOS: (state, payload) => {
        state.puestos = payload
    },

    SET_PUESTOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_PUESTO: (state, payload) => {
        state.puestos.push(payload)
    },

    UPDATE_PUESTO: (state, payload) => {
        state.puestos = state.puestos.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_PUESTO: (state, payload) => {
        state.puestos = state.puestos.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_PUESTOS: async ({ commit, state }, { filter, puestoEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await PuestoService.get({ filter, puestoEstado, ...pagination })
            if (status === 200) {
                commit("SET_PUESTOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar los puestos, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_PUESTOS: async ({ commit }) => {
        try {
            let { data, status } = await PuestoService.getAll()
            if (status === 200) {
                commit("SET_PUESTOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la acción"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_PUESTOS: async ({ commit }) => {
        try {
            let { data, status } = await PuestoService.getAllRecords()
            if (status === 200) {
                commit("SET_PUESTOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar los puestos, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_PUESTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await PuestoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_PUESTO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del puesto, inténtelo nuevamente"
            })
        }
    },

    ADD_PUESTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await PuestoService.post(payload)
            if (status === 201) {
                commit("ADD_PUESTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El puesto ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el puesto, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_PUESTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await PuestoService.put(payload)
            if (status === 200) {
                commit("UPDATE_PUESTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El puesto ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el puesto, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_PUESTO: async ({ commit }, payload) => {
        try {
            let { status, data } = await PuestoService.delete(payload)
            if (status === 204) {
                commit("DELETE_PUESTO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El puesto ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_PUESTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El puesto ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el puesto, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
